/** Number of preset avatars shipped in /public/avatars. */
export const avatarPresets = 8;

/** URL of a preset avatar reference such as "preset:3", or undefined. */
export function avatarUrl(avatar: string): string | undefined {
  const match = /^preset:([1-9]\d*)$/.exec(avatar);
  const n = match ? Number(match[1]) : NaN;

  if (!Number.isInteger(n) || n < 1 || n > avatarPresets) {
    return undefined;
  }

  return `/avatars/avatar-${String(n).padStart(2, '0')}.webp`;
}

/** Reference of preset avatar n, counted from 1. */
export function presetAvatar(n: number): string {
  return `preset:${String(n)}`;
}
